import React from 'react'
import ListDrag from "./ListDrag"


const ListDragByConfig = ({
    dragListConfig,

    itemsData,
    itemsDataCallback,

    ChildSwitchItem,

    params,
    basicUrl,

    defaultIsOpen=false,
    setAllOpen=false,
 
    pathnameAdd,
}) => {

    return (
        <div>
            {dragListConfig.map(({
                titleTransId,
                buttonTextTransId,
                type,
                dataType,
                canEdit,
                hasAddNewItem,
                hasRemoveItem,
            }, index) => {
                const { items, order, selected }  = itemsDataCallback(dataType, itemsData)

                return <ListDrag
                    key={index}
                    titleTransId={titleTransId}
                    buttonTextTransId={buttonTextTransId}
                    listId="images" ///????
                    type={type}
                    order={order}
                    items={items}
                    className=''
                    ChildSwitchItem={ChildSwitchItem}
                    selected={selected}
                    params={params}
                    basicUrl={basicUrl}
                    defaultIsOpen={defaultIsOpen}
                    setAllOpen={setAllOpen}
                    canEdit={canEdit}
                    canDelete={false}  // new
                    addItem={hasAddNewItem && canEdit && pathnameAdd ? pathnameAdd : false}
                    deleteItem={false} // new                 
                />     
            })}
        </div>
    )
}

export default ListDragByConfig



